<template>
  <v-card :loading="loading" flat>
    <v-card-title>
      <v-btn class="btn-send-sms" @click="sendSms">
        <v-icon left>mdi-send</v-icon>
        ارسال پیامک
      </v-btn>

      <v-btn class="me-2" color="primary" outlined @click="downloadTxt">
        <v-icon left>mdi-download</v-icon>
        دانلود فایل متنی
      </v-btn>

      <v-card flat width="300">
        <v-select v-model="listModel" :items="listItems" :menu-props="{offsetY: true}" dense hide-details
                  label="انتخاب دیتابیس" outlined/>
      </v-card>
    </v-card-title>

    <v-card-text v-if="listModel === 'divaar'" key="divaar">
      <v-row class="px-1" no-gutters>
        <v-col class="px-1" cols="12" lg="3" md="6">
          <v-select v-model="tableProps.length" :items="[10, 25, 50, 100, 200, 300, 400, 500, 1000]"
                    :menu-props="{offsetY: true}" dense item-text="page" item-value="page" outlined
                    @change="fetch()" @click:clear="clearField"/>
        </v-col>
        <v-col class="px-1" cols="12" lg="3" md="6">
          <v-text-field v-model="tableProps.search" append-icon="mdi-magnify" clear-icon="mdi-close-circle-outline"
                        clearable dense label="جست و جو" outlined @keydown.enter="fetch()" @click:append="fetch()"
                        @click:clear="clearField"/>
        </v-col>
        <v-col class="px-1" cols="12" lg="3" md="6">
          <v-text-field v-model="tableProps.id" append-icon="mdi-identifier" clear-icon="mdi-close-circle-outline"
                        clearable dense label="شناسه" outlined @keydown.enter="fetch()" @click:append="fetch()"
                        @click:clear="clearField"/>
        </v-col>
        <v-col class="px-1" cols="12" lg="3" md="6">
          <v-select v-model="tableProps.qr" :items="qrItems" :menu-props="{offsetY: true}" append-icon="mdi-qrcode"
                    clear-icon="mdi-close-circle-outline" clearable dense label="کیوآر" outlined
                    @change="fetch()" @click:clear="clearField"/>
        </v-col>
        <v-col class="px-1" cols="12" lg="3" md="6">
          <v-text-field v-model="tableProps.advertise_count" append-icon="mdi-advertisements"
                        clear-icon="mdi-close-circle-outline" clearable dense label="تعداد تبلیغات" outlined
                        @keydown.enter="fetch()" @click:append="fetch()" @click:clear="clearField"/>
        </v-col>
        <v-col class="px-1" cols="12" lg="3" md="6">
          <v-text-field v-model="tableProps.mobile" append-icon="mdi-phone" clear-icon="mdi-close-circle-outline"
                        clearable dense label="موبایل" outlined @keydown.enter="fetch()" @click:append="fetch()"
                        @click:clear="clearField"/>
        </v-col>
        <v-col class="px-1" cols="12" md="6">
          <v-text-field v-model="tableProps.address" append-icon="mdi-map-marker" clear-icon="mdi-close-circle-outline"
                        clearable dense label="آدرس" outlined @keydown.enter="fetch()" @click:append="fetch()"
                        @click:clear="clearField"/>
        </v-col>
      </v-row>

      <data-table :columns="columns" :data="data" :translate="translates" orderDir="desc">
        <div slot="filters"/>
      </data-table>

      <v-card flat max-width="300">
        <v-text-field v-model="tableProps.page" dense hide-details label="برو به صفحه" outlined
                      @keydown.enter="changePage">
          <template v-slot:append-outer>
            <v-btn class="btn-list ma-0" @click="changePage">
              <b>تغییر صفحه</b>
            </v-btn>
          </template>
        </v-text-field>
      </v-card>
    </v-card-text>

    <v-card-text v-else key="default">
      <data-table :columns="defaultColumns" :data="defaultData" :per-page="[10, 25, 50, 100, 200, 300, 400, 500, 1000]"
                  :translate="translates" @on-table-props-changed="defaultFetch"/>

      <v-card flat max-width="300">
        <v-text-field v-model="defaultTableProps.page" dense hide-details label="برو به صفحه" outlined
                      @keydown.enter="changePage">
          <template v-slot:append-outer>
            <v-btn class="btn-list ma-0" @click="changePage">
              <b>تغییر صفحه</b>
            </v-btn>
          </template>
        </v-text-field>
      </v-card>
    </v-card-text>

    <custom-popup v-model="smsDialog" :cons="{title: 'ارسال پیامک'} " hide-confirm max-width="700">
      <v-card class="p-8">
        <v-row no-gutters>
          <!--          <v-col cols="12" md="6" class="pa-2">-->
          <!--            <label>دریافت شماره</label>-->
          <!--            <v-radio-group v-model="phoneState" row class="mt-0" hide-details>-->
          <!--              <v-radio value="visitCard" label="شماره همراه کارت ویزیت"/>-->
          <!--              <v-radio value="userPhone" label="شماره همراه کاربر"/>-->
          <!--            </v-radio-group>-->
          <!--          </v-col>-->

          <!--          <v-col cols="12" md="6" class="pa-2 d-flex align-center">-->
          <!--            <date-picke v-model="timeouted_at" format="YYYY-MM-DD HH:mm:ss" auto-submit class="flex"-->
          <!--                        display-format="jYYYY-jMM-jDD HH:mm:ss" type="datetime" :min="min"/>-->
          <!--          </v-col>-->
        </v-row>

        <v-divider/>

        <div v-if="description.desc" class="col-md-12 mx-auto p-3"
             style="background-color: rgb(212,212,212);color: black;font-weight: bold">
          <v-icon class="float-left" @click="description.desc= '';description.id=''">mdi-delete</v-icon>
          <p>پترن انتخاب شده:</p>
          <p class="mt-1 pt-0" v-html="description.desc"></p>
        </div>

        <patterns-list v-model="description"/>

        <v-btn :loading="loading" class="mt-10 btn-send-sms " outlined @click="sendPattern">
          <v-icon left small>mdi-send</v-icon>
          ارسال
        </v-btn>

      </v-card>
    </custom-popup>
  </v-card>
</template>

<script>
import checkboxFiled from "./components/checkboxFiled"
import PatternsList from "../robot/patternsList";
import {RobotAxios} from "../../../main";

export default {
  name: "adminSendSms",

  components: {
    PatternsList,
    checkboxFiled
  },

  data() {
    return {
      data: null,
      loading: false,
      selectedRows: [],
      description: {},
      smsDialog: false,
      listModel: 'default',
      listItems: [
        {text: 'دیتابیس پیشفرض', value: 'default'},
        {text: 'دیتابیس دیوار', value: 'divaar'}
      ],
      qrItems: [
        {text: 'همه', value: false},
        {text: 'کیوآر دارد', value: '1'},
        {text: 'کیوآر ندارد', value: '0'}
      ],
      defaultTableProps: {
        search: '',
        length: 10,
        column: 'id',
        dir: 'asc',
        page: 1
      },
      tableProps: {
        search: '',
        length: 10,
        column: 'id',
        // filters: {},
        dir: 'desc',
        page: 1
      },
      defaultData: null,
      defaultColumns: [{
        label: `<input type="checkbox" id="select_all" onclick="window.Vue.$emit('selectAllListCheckBox', this)"/>`,
        component: checkboxFiled,
        meta: {
          name: 'selectThisCheckbox'
        },
        event: 'change',
        handler: this.change,
      }, {
        label: 'ردیف',
        transform: (val) => {
          let row = this.defaultData.current_page - 1;
          row = row * this.defaultData.per_page;
          return row + val.row + 1;
        }
      }, {
        label: 'ID',
        name: 'id',
        orderable: true
      }, {
        label: 'Identifier',
        name: 'identifier',
        orderable: true
      }, {
        label: 'لینک کوتاه',
        name: 'link',
        orderable: true
      }, {
        label: 'آدرس کارت ویزیت',
        name: 'url',
        transform: (val) => {
          return `<a href="https://${val.data.url + val.data.identifier}" target="_blank">${val.data.url + val.data.identifier}</a>`
        }
      }, {
        label: 'پیامک ارسال شده',
        name: 'sms_count',
        transform: (val) => {
          return val.data.sms_count ?? 0;
        }
      }],
      columns: [
        {
          label: `<input type="checkbox" id="select_all" onclick="window.Vue.$emit('selectAllListCheckBox', this)"/>`,
          component: checkboxFiled,
          meta: {
            name: 'selectThisCheckbox'
          },
          event: 'change',
          handler: this.change,
        }, {
          label: 'ردیف',
          transform: (val) => {
            let row = this.data.current_page - 1;
            row = row * this.data.per_page;
            return row + val.row + 1;
          }
        }, {
          label: 'ID',
          name: 'id',
          orderable: true
        }, {
          label: 'موضوع',
          name: 'title',
          orderable: true
        }, {
          label: 'آدرس',
          name: 'address',
          orderable: true
        }, {
          label: 'سایت',
          name: 'site',
          transform: (val) => {
            return `<a href="${val.data.site}" target="_blank">${val.data.site}</a>`
          }
        }, {
          label: 'موبایل',
          name: 'mobile',
          orderable: true
        }, {
          label: 'تلفن',
          name: 'phone',
          transform: (val) => {
            return val.data.phone ?? '--';
          }
        }, {
          label: 'تعداد تبلیغات',
          name: 'advertise_count',
          transform: (val) => {
            return val.data.advertise_count ?? 0;
          }
        }]
    }
  },

  mounted() {
    window.Vue.$on('selectAllListCheckBox', (e) => {
      this.selectAll(e.checked);
    })

    this.defaultFetch()
  },

  computed: {
    translates() {
      return {
        nextButton: 'بعدی',
        previousButton: 'قبلی',
        rowsPerPageText: 'تعداد در صفحه',
        noDataText: 'داده ای برای نمایش وجود ندارد',
        placeholderSearch: 'جستجو',
      };
    }
  },

  watch: {
    listModel(val) {
      this.defaultTableProps = {
        search: '',
        length: 10,
        column: 'id',
        dir: 'asc',
        page: 1
      }
      this.tableProps = {
        search: '',
        length: 10,
        column: 'id',
        dir: 'desc',
        page: 1
      }
      this.$forceUpdate()

      this.$nextTick(() => {
        if (val === 'default') {
          this.defaultFetch()
        } else {
          this.fetch()
        }
      })
    }
  },

  methods: {
    defaultFetch(options = this.defaultTableProps) {
      this.defaultTableProps = options

      this.loading = true

      this.$api.get('/admin/qr/sms', {
        params: options
      })
          .then(({data}) => {
            this.defaultData = data.data
            this.selectedRows = []
            this.selectAll(false)
            let selAll = document.getElementById('select_all')
            selAll.checked = false
          })
          .catch(errors => {

          })
          .finally(() => this.loading = false)
    },
    fetch(options = this.tableProps) {
      this.tableProps = options
      let pa = options
      if (pa.qr === false)
        delete pa.qr

      this.loading = true

      RobotAxios.get('api/panels', {
        params: pa
      })
          .then(({data}) => {
            this.data = data.data
            this.selectedRows = []
            this.selectAll(false)
            let selAll = document.getElementById('select_all')
            selAll.checked = false
          })
          .catch(errors => {

          })
          .finally(() => this.loading = false)
    },
    changePage() {
      if (this.listModel === 'default') {
        if (this.defaultTableProps.page === this.defaultData.current_page)
          return this.$toast.info('شما در همین صفحه هستید!');

        this.defaultFetch(this.defaultTableProps)
      } else {
        if (this.tableProps.page === this.data.current_page)
          return this.$toast.info('شما در همین صفحه هستید!');

        this.fetch(this.tableProps)
      }
    },
    selectAll(c) {
      window.Vue.$emit("selectThisCheckbox", c);
    },
    change(data, checked) {
      let field = this.listModel === 'default' ? 'id' : 'mobile'

      if (checked) {
        this.selectedRows.push(data[field]);
      } else {
        let index = this.selectedRows.indexOf(data[field])
        this.selectedRows.splice(index, 1)

        // this.selectedRows = [
        //   ...this.selectedRows.slice(0, index),
        //   ...this.selectedRows.slice(index + 1, this.selectedRows.length)
        // ]
      }

      if (this.listModel === 'default') {
        window.document.getElementById('select_all').checked = this.selectedRows.length === this.defaultData?.data?.length;
      } else {
        window.document.getElementById('select_all').checked = this.selectedRows.length === this.data?.data?.length
      }
    },
    sendSms() {
      this.smsDialog = true
    },
    sendPattern() {
      this.loading = true

      let patternCount = 0
      try {
        const regex = new RegExp(/data\d+/, 'gd');
        patternCount = this.description.content.match(regex).length
      } catch (e) {

      }

      if (this.listModel !== 'default') {
        this.$api.post('/admin/qr/sms/mobile', {
          mobiles: this.selectedRows,
          pattern_id: this.description.id,
          length: patternCount
        })
            .then(({data}) => {
              this.smsDialog = false
              this.$toast.success('ارسال با موفقیت ثبت شد')
            })
            .catch(({response}) => {
              console.log('error in send qr sms mobile: ', response)
            })
            .finally(() => this.loading = false);

      } else {
        this.$api.post('/admin/qr/sms', {
          qr_ids: this.selectedRows,
          pattern_id: this.description.id,
          length: patternCount
        })
            .then(({data}) => {
              this.smsDialog = false
              this.$toast.success('ارسال با موفقیت ثبت شد')
            })
            .catch(({response}) => {
              console.log('error in send qr sms: ', response)
            })
            .finally(() => this.loading = false);
      }
    },
    downloadTextFile(url, callback) {
      return this.$api.get(url)
          .then(response => response.text())
          .then(text => {
            // Do something with the text content of the file
            console.log(text);
          });
    },
    downloadTxt() {
      this.loading = true

      let field = '', key = '', phone = ''
      let myArray = []

      if (this.listModel === 'default') {
        key = 'defaultData'
        field = 'id'
        phone = 'identifier'

        let op = new Object(this.defaultTableProps)
        // op.length = this[key].total
        // op.page = 1

        this.$api.get('/admin/qr/sms', {
          params: op
        })
            .then(({data}) => {
              myArray = data.data?.data.map(item => item[phone])

              let myString = myArray.join("\n");
              let blob = new Blob([myString], {type: "text/plain;charset=utf-8"});

              const link = document.createElement("a");
              link.href = URL.createObjectURL(blob);
              link.download = "numbers.txt";
              link.click();
              URL.revokeObjectURL(link.href);
            })
            .catch(errors => {

            })
            .finally(() => this.loading = false)
      } else {
        key = 'data'
        field = 'mobile'
        phone = 'mobile'

        let op = new Object(this.tableProps)
        // op.length = this[key].total
        // op.page = 1

        RobotAxios.get('api/panels', {
          params: op
        })
            .then(({data}) => {
              myArray = data.data?.data.map(item => item[phone])

              let myString = myArray.join("\n");
              let blob = new Blob([myString], {type: "text/plain;charset=utf-8"});

              const link = document.createElement("a");
              link.href = URL.createObjectURL(blob);
              link.download = "numbers.txt";
              link.click();
              URL.revokeObjectURL(link.href);
            })
            .catch(errors => {

            })
            .finally(() => this.loading = false)
      }

      // myArray = this[key].data
      //     // .filter(item => this.selectedRows.includes(item[field]))
      //     .map(item => item[phone])
      // let myString = myArray.join("\n");
      // let blob = new Blob([myString], {type: "text/plain;charset=utf-8"});
      //
      // const link = document.createElement("a");
      // link.href = URL.createObjectURL(blob);
      // link.download = "numbers.txt";
      // link.click();
      // URL.revokeObjectURL(link.href);
    },
    clearField(all = false) {
      if (all) {
        this.tableProps = {
          search: '',
          length: 10,
          column: 'id',
          dir: 'desc',
          page: 1
        }
      }
      this.$nextTick(() => {
        this.fetch()
      });
    }
    // downloadTxt() {
    //   this.loading = true
    //
    //   let field = '', key = '', phone = ''
    //   let myArray = []
    //
    //   if (this.listModel === 'default') {
    //     key = 'defaultData'
    //     field = 'id'
    //     phone = 'identifier'
    //
    //     // let op = new Object(this.defaultTableProps)
    //     // op.length = this[key].total
    //     // op.page = 1
    //
    //     this.$api.get('/admin/qr/sms/list')
    //         .then(({data}) => {
    //           // myArray = data.data?.data.map(item => item[phone])
    //
    //           // let myString = myArray.join("\n");
    //           // let blob = new Blob([myString], {type: "text/plain;charset=utf-8"});
    //
    //           this.downloadTextFile(`http://127.0.0.1:8001/storage/${data.data}`, function(text) {
    //             console.log(text);
    //           })
    //
    //
    //           //
    //           // const link = document.createElement("a");
    //           // // link.href = URL.createObjectURL(blob);
    //           // link.href = `http://127.0.0.1:8001/storage/${data.data}`
    //           // link.download = "numbers.txt";
    //           // link.click();
    //           // URL.revokeObjectURL(link.href);
    //         })
    //         .catch(errors => {
    //
    //         })
    //         .finally(() => this.loading = false)
    //   } else {
    //     key = 'data'
    //     field = 'mobile'
    //     phone = 'mobile'
    //
    //     let op = new Object(this.tableProps)
    //     // op.length = this[key].total
    //     // op.page = 1
    //
    //     RobotAxios.get('api/panels', {
    //       params: op
    //     })
    //         .then(({data}) => {
    //           myArray = data.data?.data.map(item => item[phone])
    //
    //           let myString = myArray.join("\n");
    //           let blob = new Blob([myString], {type: "text/plain;charset=utf-8"});
    //
    //           const link = document.createElement("a");
    //           link.href = URL.createObjectURL(blob);
    //           link.download = "numbers.txt";
    //           link.click();
    //           URL.revokeObjectURL(link.href);
    //         })
    //         .catch(errors => {
    //
    //         })
    //         .finally(() => this.loading = false)
    //   }
    //
    //   // myArray = this[key].data
    //   //     // .filter(item => this.selectedRows.includes(item[field]))
    //   //     .map(item => item[phone])
    //   // let myString = myArray.join("\n");
    //   // let blob = new Blob([myString], {type: "text/plain;charset=utf-8"});
    //   //
    //   // const link = document.createElement("a");
    //   // link.href = URL.createObjectURL(blob);
    //   // link.download = "numbers.txt";
    //   // link.click();
    //   // URL.revokeObjectURL(link.href);
    // }
  }
}
</script>

<style scoped>
.v-input >>> .v-input__append-outer {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}
</style>